import {ReactNode} from 'react';
import {Navigate, useLocation} from '@tanstack/react-router';
import {LOGIN} from '@/anonymous/routing/paths';
import OnBoarding from '@/patient/components/layout/PatientLayout/components/OnBoarding';
import {CurrentPatientContextProvider} from '@/patient/context/CurrentPatientContext';
import {DiagnosticReportFormModalContextProvider} from '@/patient/context/DiagnosticReportFormModalContext';
import ErrorBoundary from '@/shared/components/ErrorBoundary';
import LoggedInLayout from '@/shared/components/layout/LoggedInLayout';
import {SharedDataContextProvider} from '@/shared/components/layout/LoggedInLayout/contexts/SharedDataContext';
import {useIsLoggedIn} from '@/shared/contexts/UserContext/useUserContext';
import {useRedirectCookie} from '@/shared/hooks/useRedirectCookie';
import PatientSidebar from './components/PatientSidebar';

export default function PatientLayout({children}: {children: ReactNode}) {
  const isLoggedIn = useIsLoggedIn();
  const {pathname} = useLocation();
  useRedirectCookie(isLoggedIn, pathname);

  if (!isLoggedIn) {
    return <Navigate to={LOGIN} replace />;
  }

  return (
    <ErrorBoundary>
      <SharedDataContextProvider>
        <CurrentPatientContextProvider>
          <DiagnosticReportFormModalContextProvider>
            <LoggedInLayout sidebar={PatientSidebar} tutorial={<OnBoarding />}>
              {children}
            </LoggedInLayout>
          </DiagnosticReportFormModalContextProvider>
        </CurrentPatientContextProvider>
      </SharedDataContextProvider>
    </ErrorBoundary>
  );
}
